import React, { useState } from 'react';
import { Box, Typography, Modal, Button, CircularProgress, Snackbar, Alert } from '@mui/material';
import { DashboardService } from '../service';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 400 },
    bgcolor: 'background.paper',
    boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
    borderRadius: 3,
    p: 4,
    outline: 'none'
};

export default function ResolveAlertModal({ open, onClose, onSuccess, alertId }) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ open: false, message: '', severity: 'success' });

    const handleConfirm = async () => {
        if (!alertId) return;
        setIsSubmitting(true);
        try {
            const authData = JSON.parse(localStorage.getItem('adminAuth') || '{}');
            const tenantId = authData.tenantId || '1';
            await DashboardService.resolveAlert(tenantId, alertId);
            
            setAlertInfo({
                open: true,
                message: 'Alert successfully resolved',
                severity: 'success'
            });
            
            setTimeout(() => {
                onSuccess();
                onClose();
            }, 1200);
        } catch (err) {
            console.error('Resolve alert failed:', err);
            setAlertInfo({
                open: true,
                message: err.message || 'Failed to resolve system alert. Please try again.',
                severity: 'error'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            <Modal open={open} onClose={isSubmitting ? null : onClose}>
                <Box sx={modalStyle}>
                    <Typography variant="h6" fontWeight="bold" mb={2}>
                        Confirm Resolve Alert
                    </Typography>

                    <Typography variant="body2" color="text.secondary" mb={3}>
                        Are you sure you want to resolve this system alert? It will be moved from the Active view to the Resolved logs.
                    </Typography>

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                        <Button 
                            onClick={onClose} 
                            disabled={isSubmitting}
                            variant="text"
                            sx={{ textTransform: 'none', fontWeight: 'bold' }}
                        >
                            Cancel
                        </Button>
                        <Button 
                            onClick={handleConfirm}
                            variant="contained" 
                            color="primary"
                            disabled={isSubmitting}
                            startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : null}
                            sx={{ textTransform: 'none', fontWeight: 'bold', px: 3 }}
                        >
                            Confirm Resolve
                        </Button>
                    </Box>
                </Box>
            </Modal>

            <Snackbar
                open={alertInfo.open}
                autoHideDuration={4000}
                onClose={() => setAlertInfo({ ...alertInfo, open: false })}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert 
                    onClose={() => setAlertInfo({ ...alertInfo, open: false })} 
                    severity={alertInfo.severity} 
                    variant="filled" 
                    sx={{ width: '100%' }}
                >
                    {alertInfo.message}
                </Alert>
            </Snackbar>
        </>
    );
}
